import Main from '../components/main'
import Blank from '../components/blank'
import ProMain from '../components/pro-main'

export default [
    {
        path: '/',
        name: 'loading',
        redirect: '/member/index'
    },
    {
        path: '/member',
        name: 'member',
        component: Main,
        children: [
            {
                path: 'index',
                name: 'memberCenter',
                meta: {
                    title: '会员中心'
                },
                component: () => import('@/view/member-center/')
            },
            {
                path: 'shop',
                name: 'memberShop',
                meta: {
                    title: '积分商城'
                },
                component: Blank,
                children: [
                    {
                        path: 'index',
                        name: 'shopIndex',
                        meta: {
                            title: '积分商城'
                        },
                        component: () => import('@/view/member-shop/shop/')
                    },
                    {
                        path: 'integral',
                        name: 'integralList',
                        meta: {
                            title: '积分明细'
                        },
                        component: () => import('@/view/member-shop/integral-list/')
                    },
                    {
                        path: 'gift',
                        name: 'giftList',
                        meta: {
                            title: '我的礼品'
                        },
                        component: () => import('@/view/member-shop/gift-list/')
                    }
                ]
            },
            {
                path: 'welfare',
                name: 'memberWelfare',
                meta: {
                    title: '我的福利'
                },
                component: () => import('@/view/member-welfare/')
            }
        ]
    },
    {
        path: '/commodity',
        name: 'commodity',
        component: ProMain,
        children: [
            {
                path: 'detail',
                name: 'commodityDetail',
                meta: {
                    title: '礼品详情'
                },
                component: () => import('@/view/commodity-detail/')
            }
        ]
    },
    {
        path: '/recommend',
        name: 'recommend',
        component: Blank,
        children: [
            {
                path: 'courtesy',
                name: 'recommendCourtesy',
                redirect: {
                    path: '/member/index',
                    query: {
                        showRec: true
                    }
                },
                meta: {
                    title: '推荐有礼'
                },
                component: () => import('@/view/recommend/recommend-courtesy/')
            },
            {
                path: 'activityRule',
                name: 'activityRule',
                meta: {
                    title: '推荐规则'
                },
                component: () => import('@/view/recommend/activity-rule/')
            },
            {
                path: 'list',
                name: 'recommendList',
                meta: {
                    title: '推荐记录'
                },
                component: () => import('@/view/recommend/recommend-list/')
            }
        ]
    },
    {
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/view/error-page/401.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/view/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/view/error-page/404.vue')
    }
]
